import React, { useState, useEffect } from "react";
import "./index.css";

interface ToggleSwitchProps {
  initialChecked?: boolean;
  menuId: string;
  onChange?: (menuId: string, checked: boolean) => void;
  disabled?: boolean;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  initialChecked = false,
  menuId,
  onChange,
  disabled = false,
}) => {
  const [checked, setChecked] = useState(initialChecked);

  useEffect(() => {
    setChecked(initialChecked);
  }, [initialChecked]);

  const handleToggle = () => {
    if (disabled) return;
    const newChecked = !checked;
    setChecked(newChecked);
    if (onChange) {
      onChange(menuId, newChecked);
    }
  };

  return (
    <div
      className={`toggle-switch ${checked ? "checked" : ""} ${disabled ? "disabled" : ""
        }`}
      onClick={handleToggle}
    >
      <div className="toggle-switch-handle"></div>
    </div>
  );
};

export default ToggleSwitch;
